/** @module Camunda/_BpmnWidget */
define([
	"bpmn-js/lib/NavigatedViewer",
	"dojo/_base/declare",
	"underscore",
	"csi/_base/Deferred",
	"csi/html/Widget",

	// other needed modules
	"css!bpmn-js/dist/assets/diagram-js.css"
], function(NavigatedViewer, declare, _, Deferred, Widget, _FullPageViewMixin) {

	const BpmnViewer = NavigatedViewer.default;
	const ZOOM_DELTA = 0.1;

	return declare(Widget, {
		CSS_COMPLETED_TASK: "csi-camunda-completed-task",
		CSS_CANCELLED_TASK: "csi-camunda-canceled-task",
		CSS_ERROR_TASK: "csi-camunda-error-task",
		CSS_NOT_STARTED_TASK: "csi-camunda-not-started-task",
		CSS_SUSPENDED_TASK: "csi-camunda-suspended-task",
		CSS_RUNNING_TASK: "csi-camunda-running-task",
		CSS_SERVICE_TASK: "csi-camunda-service-task",
		CSS_USER_TASK: "csi-camunda-user-task",

		SERVICE_TASK: "bpmn:ServiceTask",
		USER_TASK: "bpmn:UserTask",

		plugins: [],

		/** @property {BpmnViewer} _bpmn - BPM viewer */
		_bpmn: null,

		/**
		 * Zoom in
		 */
		onActionZoomIn: function() {
			this._applyBpmnZoom(ZOOM_DELTA);
		},

		/**
		 * Zoom out
		 */
		onActionZoomOut: function() {
			this._applyBpmnZoom(-ZOOM_DELTA);
		},

		/**
		 * Fit diagram to available space
		 */
		onActionZoomReset: function() {
			this._bpmn.get('canvas').zoom('fit-viewport', 'auto');
		},

		/**
		 * Extension point called when element is clicked
		 * @param {string} elementId
		 * @param {string} type
		 * @param {string} name
		 * @param {string} description
		 */
		onClickElement: function(elementId, type, name, description) { },

		/**
		 * Extension point called when the mouse is hovering over the element
		 * @param {string} elementId
		 * @param {string} type
		 * @param {string} name
		 * @param {string} description
		 */
		onHoverElement: function(elementId, type, name, description) { },

		/**
		 * Extension point called when the mouse is out of the element
		 * @param {string} elementId
		 * @param {string} type
		 * @param {string} name
		 * @param {string} description
		 */
		onOutElement: function(elementId, type, name, description) { },

		/**
		 * Add SVG definition
		 * @param {string} def - definition to add
		 */
		_addDef: function(def) {
			var defs = $(this._bpmn.get("canvas")._svg).find("defs")[0];
			if (defs) {
				defs.innerHTML += def;
			}
		},

		/**
		 * Add CSS class to task
		 * @param {string} taskId
		 * @param {string} css
		 */
		_addTaskCSS: function(taskId, css) {
			this._bpmn.get('canvas').addMarker(taskId, css);
		},

		/**
		 * Adjust zoom factor for viewer by given delta
		 * @param {number} delta
		 */
		_applyBpmnZoom: function(delta) {
			const canvas = this._bpmn.get('canvas');
			const viewbox = canvas.viewbox();
			const inner = viewbox.inner;
			const scale = viewbox.scale;
			const center = {
				x: scale * (inner.x - viewbox.x + inner.width / 2),
				y: scale * (inner.y - viewbox.y + inner.height / 2)
			};

			canvas.zoom(scale + delta, center);
		},

		/**
		 * Return task element
		 * @param {string} taskId
		 * @return {Object}
		 */
		_getTaskElement: function(taskId) {
			return this._bpmn.get('elementRegistry').get(taskId);
		},

		/**
		 * Return revision node that holds BPMN definition
		 * @return {string}
		 */
		_getProcessDefinitionRevisionUrl: function() {
			return this.urlRoot;
		},

		/**
		 * Callback from bpmn-js when the user interacts with any element
		 * @param {Event} e
		 * @param {Function} callback
		 */
		_onEventBpmnViewer: function(e, callback) {
			const {id, type, businessObject} = e.element;
			const documentElement = businessObject.get("documentation");
			const taskName = businessObject.get("name");
			const taskDescription = documentElement.length ? documentElement[0].text : "";

			callback.call(this, id, type, taskName, taskDescription);
		},

		/**
		 * @override
		 * Create BPMN viewer
		 */
		_processDeferreds: function() {
			const revisionUrl = this._getProcessDefinitionRevisionUrl();
			const revision = this.cacheView.get(revisionUrl);
			const viewer = this._bpmn = new BpmnViewer({
				container: this.getContentRoot()
			});

			return viewer.importXML(revision.BPMN20XML).then(() => {
				this.onActionZoomReset();

				// hook to events
				const eventBus = viewer.get('eventBus');
				eventBus.on("element.click", (e) => this._onEventBpmnViewer(e, this.onClickElement));
				eventBus.on("element.hover", (e) => this._onEventBpmnViewer(e, this.onHoverElement));
				eventBus.on("element.out", (e) => this._onEventBpmnViewer(e, this.onOutElement));
			});
		},

		/**
		 * Select task in viewer with given id
		 * @param {string} taskId
		 */
		_selectTask: function(taskId) {
			const element = this._getTaskElement(taskId);
			if (element) {
				this._bpmn.get('selection').select(element);
			}
		}
	});
});
